import { Row, Col, Form } from "react-bootstrap";

const ProductHierarchySelection = ({
    // Branch props
    availableBranches,
    selectedBranches,
    handleBranchSelection,
    // Brand props
    availableBrands,
    selectedBrands,
    handleBrandSelection,
    // Category props
    availableCategories,
    selectedCategories,
    handleCategorySelection,
    // Subcategory props
    availableSubCategories,
    selectedSubCategories,
    handleSubCategorySelection,
    // Phenotype props
    availablePhenotypes,
    selectedPhenotypes,
    handlePhenotypeSelection,
    // Product props
    availableProducts,
    selectedProducts,
    handleProductSelection,
    // Helper function
    getValue
}) => {
    return (
        <>
            {/* Branch Selection */}
            <Row className='mb-4'>
                <Col sm={12}>
                    <Form.Group className='form-group'>
                        <Form.Label>Branch *</Form.Label>
                        <div
                            className='checkbox-group'
                            style={{
                                maxHeight: '280px',
                                overflowY: 'auto',
                                padding: '8px 0',
                                transform: 'scale(0.85)',
                                transformOrigin: 'top left'
                            }}
                        >
                            {availableBranches.map((branch, index) => (
                                <div
                                    key={`branch-${index}-${branch}`}
                                    className="form-check"
                                    style={{
                                        padding: '6px 8px',
                                        fontSize: '14px',
                                        minHeight: 'auto'
                                    }}
                                >
                                    <input
                                        className="form-check-input"
                                        type='checkbox'
                                        id={`branch-${index}`}
                                        checked={selectedBranches.includes(branch)}
                                        onChange={() => handleBranchSelection(branch)}
                                        style={{
                                            width: '14px',
                                            height: '14px',
                                            marginRight: '8px',
                                            accentColor: '#000000'
                                        }}
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor={`branch-${index}`}
                                        style={{
                                            fontSize: '13px',
                                            fontWeight: '500'
                                        }}
                                    >
                                        {branch}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </Form.Group>
                </Col>
            </Row>

            {/* Brands (shown after branch selection) */}
            {selectedBranches.length > 0 && availableBrands.length > 0 && (
                <Row className='mb-4'>
                    <Col sm={12}>
                        <Form.Group className='form-group'>
                            <Form.Label>Brands</Form.Label>
                            <div
                                className='checkbox-group'
                                style={{
                                    maxHeight: '280px',
                                    overflowY: 'auto',
                                    padding: '8px 0',
                                    transform: 'scale(0.85)',
                                    transformOrigin: 'top left'
                                }}
                            >
                                {availableBrands.map((brandName, index) => {
                                    const brand = typeof brandName === 'string' ? brandName : String(brandName);
                                    return (
                                        <div
                                            key={`brand-${index}-${brand}`}
                                            className="form-check"
                                            style={{
                                                padding: '6px 8px',
                                                fontSize: '14px',
                                                minHeight: 'auto'
                                            }}
                                        >
                                            <input
                                                className="form-check-input"
                                                type='checkbox'
                                                id={`brand-${index}`}
                                                checked={selectedBrands.includes(brand)}
                                                onChange={() => handleBrandSelection(brand)}
                                                style={{
                                                    width: '14px',
                                                    height: '14px',
                                                    marginRight: '8px',
                                                    accentColor: '#000000'
                                                }}
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor={`brand-${index}`}
                                                style={{
                                                    fontSize: '13px',
                                                    fontWeight: '500'
                                                }}
                                            >
                                                {brand}
                                            </label>
                                        </div>
                                    );
                                })}
                            </div>
                        </Form.Group>
                    </Col>
                </Row>
            )}

            {/* Categories (shown after brand selection) */}
            {selectedBrands.length > 0 && availableCategories.length > 0 && (
                <Row className='mb-4'>
                    <Col sm={12}>
                        <Form.Group className='form-group'>
                            <Form.Label>Categories</Form.Label>
                            <div
                                className='checkbox-group'
                                style={{
                                    maxHeight: '280px',
                                    overflowY: 'auto',
                                    padding: '8px 0',
                                    transform: 'scale(0.85)',
                                    transformOrigin: 'top left'
                                }}
                            >
                                {availableCategories.map((category, index) => {
                                    const categoryValue = getValue(category);

                                    if (!categoryValue || categoryValue === '{}' || categoryValue === 'null') {
                                        return null;
                                    }

                                    return (
                                        <div
                                            key={`category-${index}`}
                                            className="form-check"
                                            style={{
                                                padding: '6px 8px',
                                                fontSize: '14px',
                                                minHeight: 'auto'
                                            }}
                                        >
                                            <input
                                                className="form-check-input"
                                                type='checkbox'
                                                id={`category-${index}`}
                                                checked={selectedCategories.includes(categoryValue)}
                                                onChange={() => handleCategorySelection(categoryValue)}
                                                style={{
                                                    width: '14px',
                                                    height: '14px',
                                                    marginRight: '8px',
                                                    accentColor: '#000000'
                                                }}
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor={`category-${index}`}
                                                style={{
                                                    fontSize: '13px',
                                                    fontWeight: '500'
                                                }}
                                            >
                                                {categoryValue}
                                            </label>
                                        </div>
                                    );
                                })}
                            </div>
                        </Form.Group>
                    </Col>
                </Row>
            )}

            {/* Sub Categories (shown after brand selection) */}
            {selectedBrands.length > 0 && availableSubCategories.length > 0 && (
                <Row className='mb-4'>
                    <Col sm={12}>
                        <Form.Group className='form-group'>
                            <Form.Label>Sub Categories</Form.Label>
                            <div
                                className='checkbox-group'
                                style={{
                                    maxHeight: '280px',
                                    overflowY: 'auto',
                                    padding: '8px 0',
                                    transform: 'scale(0.85)',
                                    transformOrigin: 'top left'
                                }}
                            >
                                {availableSubCategories.map((subCategory, index) => {
                                    const subCatValue = getValue(subCategory);

                                    if (!subCatValue || subCatValue === '{}' || subCatValue === 'null') {
                                        return null;
                                    }

                                    return (
                                        <div
                                            key={`subcat-${index}`}
                                            className="form-check"
                                            style={{
                                                padding: '6px 8px',
                                                fontSize: '14px',
                                                minHeight: 'auto'
                                            }}
                                        >
                                            <input
                                                className="form-check-input"
                                                type='checkbox'
                                                id={`subcat-${index}`}
                                                checked={selectedSubCategories.includes(subCatValue)}
                                                onChange={() => handleSubCategorySelection(subCatValue)}
                                                style={{
                                                    width: '14px',
                                                    height: '14px',
                                                    marginRight: '8px',
                                                    accentColor: '#000000'
                                                }}
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor={`subcat-${index}`}
                                                style={{
                                                    fontSize: '13px',
                                                    fontWeight: '500'
                                                }}
                                            >
                                                {subCatValue}
                                            </label>
                                        </div>
                                    );
                                })}
                            </div>
                        </Form.Group>
                    </Col>
                </Row>
            )}

            {/* Phenotypes (shown after brand selection) */}
            {selectedBrands.length > 0 && availablePhenotypes.length > 0 && (
                <Row className='mb-4'>
                    <Col sm={12}>
                        <Form.Group className='form-group'>
                            <Form.Label>Phenotypes</Form.Label>
                            <div
                                className='checkbox-group'
                                style={{
                                    maxHeight: '280px',
                                    overflowY: 'auto',
                                    padding: '8px 0',
                                    transform: 'scale(0.85)',
                                    transformOrigin: 'top left'
                                }}
                            >
                                {availablePhenotypes
                                    .filter(phenotype => phenotype)
                                    .map((phenotype, index) => {
                                        const phenotypeValue = getValue(phenotype);

                                        if (!phenotypeValue || phenotypeValue === '{}' || phenotypeValue === 'null') {
                                            return null;
                                        }

                                        return (
                                            <div
                                                key={`phenotype-${index}`}
                                                className="form-check"
                                                style={{
                                                    padding: '6px 8px',
                                                    fontSize: '14px',
                                                    minHeight: 'auto'
                                                }}
                                            >
                                                <input
                                                    className="form-check-input"
                                                    type='checkbox'
                                                    id={`phenotype-${index}`}
                                                    checked={selectedPhenotypes.includes(phenotypeValue)}
                                                    onChange={() => handlePhenotypeSelection(phenotypeValue)}
                                                    style={{
                                                        width: '14px',
                                                        height: '14px',
                                                        marginRight: '8px',
                                                        accentColor: '#000000'
                                                    }}
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor={`phenotype-${index}`}
                                                    style={{
                                                        fontSize: '13px',
                                                        fontWeight: '500'
                                                    }}
                                                >
                                                    {phenotypeValue}
                                                </label>
                                            </div>
                                        );
                                    })}
                            </div>
                        </Form.Group>
                    </Col>
                </Row>
            )}

            {/* Products */}
            {selectedBrands.length > 0 && availableProducts.length > 0 && (
                <Row className='mb-4'>
                    <Col sm={12}>
                        <Form.Group className='form-group'>
                            <Form.Label>
                                Products ({selectedProducts.length} of {availableProducts.length} selected)
                            </Form.Label>
                            <div
                                className='products-grid-container'
                                style={{
                                    gridTemplateColumns: 'repeat(auto-fill, minmax(90px, 1fr))',
                                    gap: '8px',
                                    padding: '8px',
                                    maxHeight: '400px'
                                }}
                            >
                                {availableProducts.map((product, index) => {
                                    const isSelected = selectedProducts.includes(product.inventoryId);
                                    const productName = product.Buyermenuproductname || 'Unnamed Product';
                                    const productImage = product.Primaryproductimagefirstdisplayed || '';

                                    return (
                                        <div
                                            key={`product-${product.inventoryId}-${index}`}
                                            className={`product-card ${isSelected ? 'selected' : ''}`}
                                            onClick={() => handleProductSelection(product.inventoryId)}
                                            role="button"
                                            tabIndex={0}
                                            aria-label={`Select ${product.Buyermenuproductname || 'product'}`}
                                            aria-pressed={isSelected}
                                            style={{
                                                padding: '6px',
                                                borderWidth: isSelected ? '2px' : '1px'
                                            }}
                                        >
                                            <div className='product-image-wrapper' style={{ marginBottom: '6px' }}>
                                                {productImage ? (
                                                    <img
                                                        src={productImage}
                                                        alt={productName}
                                                        className='product-image'
                                                        onError={(e) => {
                                                            e.target.src = 'https://via.placeholder.com/150?text=No+Image';
                                                        }}
                                                    />
                                                ) : (
                                                    <div className='product-image-placeholder' style={{ fontSize: '8px' }}>
                                                        No Image
                                                    </div>
                                                )}
                                                <div
                                                    className='product-checkbox'
                                                    style={{
                                                        top: '4px',
                                                        right: '4px',
                                                        padding: '2px'
                                                    }}
                                                >
                                                    <input
                                                        type='checkbox'
                                                        checked={isSelected}
                                                        onChange={() => { }}
                                                        onClick={(e) => e.stopPropagation()}
                                                        style={{
                                                            width: '16px',
                                                            height: '16px',
                                                            cursor: 'pointer',
                                                            margin: 0,
                                                            accentColor: '#000000'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className='product-info'>
                                                <h6
                                                    className='product-name'
                                                    title={productName}
                                                    style={{
                                                        fontSize: '11px',
                                                        marginBottom: '3px',
                                                        lineClamp: 2,
                                                        WebkitLineClamp: 2
                                                    }}
                                                >
                                                    {productName}
                                                </h6>
                                                <small
                                                    className='product-id'
                                                    style={{ fontSize: '9px' }}
                                                >
                                                    ID: {product.inventoryId.substring(0, 6)}...
                                                </small>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </Form.Group>
                    </Col>
                </Row>
            )}
        </>
    );
};

export default ProductHierarchySelection;

